/**
 * Customer Custom Invoice Templates Registry
 * 
 * If a customer needs a custom invoice/bill design (e.g. thermal POS receipt, custom jewel receipt, specific A4 format):
 * 1. Create your template component in this directory (e.g., `client/src/custom/templates/ThermalReceipt.jsx`)
 * 2. Export it in the array below.
 * 
 * Any templates added here will automatically appear in the Invoice Print dialog and Company Settings.
 */

export const customInvoiceTemplates = [
  // Example:
  // {
  //   id: "thermal-receipt",
  //   name: "3-Inch Thermal Receipt",
  //   desc: "Compact receipt for point-of-sale thermal printers",
  //   component: ThermalReceiptComponent
  // }
];

export default customInvoiceTemplates;
